export default __webpack_public_path__ + "static/media/Inventory.f1a09872.svg";